
$(document).ready(function () {
   jQuery('main').insertAfter('header');
  countDownIni('.flip-countdown,.js-flip-countdown');
    // /********* On scroll heder Sticky *********/
    function initHeaderSticky() {
        if (jQuery(document).height() > jQuery(window).height()) {
            if (jQuery(this).scrollTop() > 100) {
                jQuery('.site-header').addClass("fixed");
            } else {
                jQuery('.site-header').removeClass("fixed");
            }
        }
    }

    $(document).ready(function () {
        initHeaderSticky()
    });
    $(window).on('resize scroll', function () {
        initHeaderSticky()
    });

    // /********* On scroll heder back *********/
    var prevScrollpos = window.pageYOffset;
    window.onscroll = function () {
        var currentScrollPos = window.pageYOffset;
        if (prevScrollpos > currentScrollPos) {
            document.getElementById("header-sticky").style.top = "0";
        } else {
            document.getElementById("header-sticky").style.top = "-100px";
        }
        prevScrollpos = currentScrollPos;
    }

    /******  menu hover  ******/
    $(".menu-lnk.has-item").hover(function () {
        $(this).toggleClass("menu_active");
        $(this).find(".menu-dropdown").toggleClass("open_menu");
        $("body").toggleClass("no_scroll");
    });
  
     // currency-nice-select
    $('body').on('click', '.country-name .nice-select', function (e) {
      e.stopPropagation(); // Stop the event from propagating to the body
      $(this).toggleClass('open');
    });
    $('body').on('click', function (e) {
      $('.country-name .nice-select').removeClass('open');
    });

  // currency
    function currencyFormSubmit(event) {
      event.target.form.submit();
    }
    
    document.querySelectorAll('.country-name .nice-select .list li').forEach(function (currencyItem) {
      currencyItem.addEventListener('click', function () {
        // Trigger change event on the associated select element
        var selectElement = this.closest('.country-name').querySelector('select');
        if (selectElement) {
          // Set the selected option based on the data-currency attribute of the clicked li
          selectElement.value = this.dataset.currency;
          
          // Trigger change event
          var event = new Event('change', { bubbles: true });
          selectElement.dispatchEvent(event);
    
          // Submit the form
          currencyFormSubmit({ target: selectElement });
        }
      });
    });
    /********* Mobile Menu ********/
    $('.mobile-menu-button').on('click', function (e) {
        e.preventDefault();
        setTimeout(function () {
            $('body').addClass('no_scroll active_menu');
            $(".mobile-menu-wrapper").toggleClass("active_menu");
            $('.overlay').addClass('active');
        }, 50);
    });
    $('body').on('click', '.overlay, .menu-close-icon svg', function (e) {
        e.preventDefault();
        $('body').removeClass('no_scroll active_menu');
        $(".mobile-menu-wrapper").removeClass("active_menu");
        $('.overlay').removeClass('active');
    });

    /********* mobile stickybar ********/
    $(window).scroll(function () {
        if ($(window).scrollTop() > 100) {
            $(".mobile-stickybar").addClass('show');
        } else {
            $(".mobile-stickybar").removeClass('show');
        }
    });

    /*********  Multi-level accordion nav (header & faq) ********/
    $('.acnav-label').click(function () {
        var label = $(this);
        var parent = label.parent('.has-children');
        var list = label.siblings('.acnav-list');
        if (parent.hasClass('is_open')) {
            list.slideUp('fast');
            parent.removeClass('is_open');
        }
        else {
            list.slideDown('fast');
            parent.addClass('is_open');
        }
    });

    //  Header Search Popup  // 
    $(".search-header a").click(function () {
        $(".search-popup").toggleClass("active");
        $("body").toggleClass("no_scroll");
        $('.overlay').addClass('active');
        $('body').addClass('search-overlay');
    });
    $(".close-search ,.overlay").click(function () {
        $(".search-popup").removeClass("active");
        $("body").removeClass("no_scroll"); +
            $('.overlay').removeClass('active');
        $('body').removeClass('search-overlay');
    });

     // ============= cart popup============
     if ($('body').hasClass('cart')) {
            // Disable click on the cart-header div
            $('.cart-header').on('click', function(event) {
                event.preventDefault();
                return false;
            });
        }else{
    
        $('.cart-header').on('click', function (e) {
        e.preventDefault();
         $('body').addClass('no_scroll cartopen');
            $('.overlay').addClass('active');
      });
        
      }
    
      $('body').on('click', '.overlay.cart-overlay, .closecart', function (e) {
        e.preventDefault();
        $('.overlay').removeClass('active');
        $('body').removeClass('no_scroll cartopen');
        $('.coupon-popup').removeClass('active');
        $('.gift-popup').removeClass('active');
      });
    /*********coupon popup ********/
      $(document).on('click', '.coupan-icon', function () {
        $(".coupon-popup").toggleClass("active");
      });
      $(document).on('click', '.gift-icon', function () {
        $(".coupon-popup").removeClass("active");
      });
      $(document).on('click', '.close-coupon', function () {
        $(".coupon-popup").removeClass("active");
      });
  
  // coupan code
    $('body').on('keyup','.discount-coupon', function() {
     var apply_href = $('.apply').attr("href").split('discount=')[0];
     var val = $(this).val();
      $('.apply').attr("href",apply_href+'discount='+val);
       $('.apply').trigger('click');
    });
  
/*********gift popup ********/
    $(document).on('click', '.gift-icon', function () {
    $(".gift-popup").addClass("active");
  });
  $(document).on('click', '.coupan-icon', function () {
    $(".gift-popup ").removeClass("active");
  });
  $(document).on('click', '.close-gift', function () {
    $(".gift-popup").removeClass("active");
  });

 /******* Quick View Popup JS *******/
$(".quick-close-btn").click(function () {
    $(".quick-view-popup").removeClass("active");
    $("body").removeClass("no_scroll quick-view-active");
    $(".overlay").removeClass("quick-active");
});

$('body').on('click', '.quickview-btn', function(e) {
    e.preventDefault();

    
    var href = '/products/' + $(this).data('handle') + '?view=qv';
    
    // Make an AJAX request to fetch product data
    $.get(href, function(product) {
        // Populate the popup with the fetched product data
        $('.quickview_popup_data').html(product);
        
        // Initialize Swiper for image slider
        var swiper = new Swiper(".quickview-image-slider", {
            slidesPerView: 1,
            spaceBetween: 15,
            loop: false,
            speed: 800,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            breakpoints: {
                992: {
                    slidesPerView: 1,
                },
                0: {
                    slidesPerView: 1,
                }
            },
        });
      
    });
    
    $(".quick-view-popup").addClass("active");
    $("body").addClass("no_scroll quick-view-active");
    $(".overlay").addClass("quick-active");
});

$('body').on('click', '.quickview_popup_data .radio-buttons .button', function() {
    var data_val = $(this).children('input:checked').val();
    $(this).parents('.color-variant-swatch').find('.option-label').text(data_val);
    
    var selectedValues = [];

  // Collect selected option values
  $('.quickview_popup_data .radio-buttons .button input:checked').each(function() {
    var selectedValue = $(this).val();
    
    if (selectedValue) {
      selectedValues.push(selectedValue);
    }
  });
var joinedValues = selectedValues.join(' / ');

  $('.variant-qv').each(function() {
    var variant_title = $(this).data('title');
    var variant_img = $('.variant-qv[data-title="'+variant_title+'"]').data('img');
    var variant_price = $('.variant-qv[data-title="'+variant_title+'"]').data('price');
    var qv_btn =  $('.variant-qv[data-title="'+variant_title+'"]').data('avail');
    var variant_id = $('.variant-qv[data-title="'+variant_title+'"]').data('id');

    // Check if variant_title exists in the selectedValues array
    if(variant_title === joinedValues){
      
      var variantImageIndex = $('.quickview-image-slider .quickview-card-image img[data-img="'+variant_img+'"]').parents('.qv-pro-slider-img').index();
      new Swiper('.quickview-image-slider').slideTo(variantImageIndex);

      $('.qv-price').find('.price-item--regular').text(variant_price);

      if (qv_btn === true) {
        $('.quickview_popup_data .product-form__submit').find('span').text('Add to Cart');
        $('.quickview_popup_data .product-form__submit').removeAttr('disabled');
      } else {
        $('.quickview_popup_data .product-form__submit').find('span').text('Sold out');
        $('.quickview_popup_data .product-form__submit').attr('disabled', 'disabled');
         $('.quickview_popup_data .product-form__submit > svg').remove();
      }

      $('input[name="id"]').val(variant_id);
    }
  });
});
/******* quick-view-popup end *******/


    /**************************/
    // Cookie Js // 
    /**************************/
    $('.cookie-accept-btn').click(function () {
        $('.cookie-popup').slideUp();
    });

    /**************************/
    // progress-wrap Js // 
    /**************************/
    function scrollIndicator() {
        const scrollTop = document.documentElement.scrollTop;
        const scrollHeight = document.documentElement.scrollHeight;
        const windowHeight = document.documentElement.clientHeight;
        const maxScrollTop = scrollHeight - windowHeight;
        const scrollPointBottom = $('.scroll-line').outerHeight();
        const scrollPointPos = (scrollTop * scrollPointBottom) / maxScrollTop;

        if (scrollTop > 200) {
            $('.scroll-progress').addClass('visible');
        } else {
            $('.scroll-progress').removeClass('visible');
        }

        anime({
            targets: '.scroll-point',
            perspective: '500px',
            translateX: 0,
            translateY: scrollPointPos,
            translateZ: '0',
            easing: 'easeOutCirc'
        });
    }

    $(document).ready(function () {
        // Initial call on document ready
        scrollIndicator();

        // Attach scroll event listener
        $(document).scroll(function () {
            scrollIndicator();
        });
    });
    /*********  Size Popup  ********/ 
    $(".size-btn").click(function() { 
      $(".size-popup").toggleClass("active");   
      $("body").toggleClass("no_scroll");
  });
  $(".close-search").click(function() { 
      $(".size-popup").removeClass("active"); 
      $("body").removeClass("no_scroll");
  });
  $(".close-btn").click(function() { 
      $(".size-popup").removeClass("active"); 
      $("body").removeClass("no_scroll");
  });
  $('body').on('click', '.overlay, .close-btn', function (e) {
  e.preventDefault();
  $('body').removeClass('no_scroll search_open');
  $(".search-popup").removeClass("active");
  $('.overlay').removeClass('active');
});
     /*********  ask qustion Popup  ********/
    $(".pro-features li a.ask-qus").click(function () {
        $(".ask-qus-popup").toggleClass("active");
        $("body").toggleClass("no_scroll");
      $('.overlay').addClass('active');
    });
    $(".close-btn").click(function () {
        $(".ask-qus-popup").removeClass("active");
        $("body").removeClass("no_scroll");
      $('.overlay').removeClass('active');
    });

   /******* Subscribe popup Js *******/
    if ($('.subscribe-popup').length > 0) {
    $('body').addClass('no_scroll');
       $(".subscribe-overlay").addClass("active");
        $(".subscribe-popup").addClass("active");
  }
    $('.close-sub-btn').click(function () {
      $('.subscribe-popup').removeClass("active");
      $(".subscribe-overlay").removeClass("active");
      $('body').removeClass('no_scroll');
    });   

       // sticky addtocart button

if($('body').hasClass('product')){
$.fn.isInViewport = function() {
    var elementTop = this.offset().top;
    var elementBottom = elementTop + this.outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
};

    $(window).scroll(function() {
        if ($('.cart-btn.product-button').isInViewport()) {
          $('.products-add-cart-sticky').removeClass('show-btn');
        } else {
          $('.products-add-cart-sticky').addClass('show-btn');
        }
    });
    }

   $(".stickyOpt.nice-select").on('click', function(){
		$(this).toggleClass('open');
    });
    $(".stickyOpt .vrOpt").on('click', function(e){
        var sectionId = $('.pdp-page-main-sec').attr('data-section-id');
		var number = $(this).data('no');
        $(".stickyOpt .selectedOpt").html($(this).html());
      	$(this).toggleClass('open');
      	this.productvariants = JSON.parse(document.getElementById('variants'+sectionId).innerHTML);
        var stOpt = this.productvariants[number],
            o1 = stOpt.option1, o2 = stOpt.option2, o3 = stOpt.option3;
        $('.stickCtImg').attr('src', stOpt.featured_image.src+'&width=100');
        if($('select.single-option-selector').length){
        } else {
            if(o2 != null){var stOpt2 = o2.replace(/'/g, "\\'");$(".swatchInput[value='"+stOpt2+"']").prop("checked",true)}
            if(o3 != null){var stOpt3 = o3.replace(/'/g, "\\'");$(".swatchInput[value='"+stOpt3+"']").prop("checked",true)}
            if(o1 != null){var stOpt1 = o1.replace(/'/g, "\\'");$(".swatchInput[value='"+stOpt1+"']").trigger('click')}
        }
    });
  
      $(".stickyQty .quantity__button").on("click", function(){
      var qtyField = $('.mianQty'),oldValue = $(qtyField).val(),newVal = 1;
      if ($(this).is(".quantity-increment")) {
        newVal = parseInt(oldValue) + 1;
      } else if (oldValue > 1) {
        newVal = parseInt(oldValue) - 1;
      }
      $(qtyField).val(newVal).trigger('change');
    });
    $('.mianQty').on("change", function(){
      $('#stquantity').val($(this).val());
    });
// end sticky

    /****  TAB Js ****/
    $("ul.tabs li").click(function () {
        var $this = $(this);
        var $theTab = $(this).attr("data-tab");
        if ($this.hasClass("active")) {
        } else {
            $this
                .closest(".tabs-wrapper")
                .find("ul.tabs li, .tabs-container .tab-content")
                .removeClass("active");
            $(
                '.tabs-container .tab-content[id="' +
                $theTab +
                '"], ul.tabs li[data-tab="' +
                $theTab +
                "]"
            ).addClass("active");
        }
        $(this).addClass("active");
    });

    /**************************/
    //      footer acnav     // 
    /*************************/
    $(".footer-acnav").on("click", function () {
        if ($(window).width() < 768) {
            if ($(this).hasClass("is_open")) {
                $(this).removeClass("is_open");
                $(this).siblings(".footer-acnav-list").slideUp(200);
            } else {
                $(".footer-acnav").removeClass("is_open");
                $(this).addClass("is_open");
                $(".footer-acnav-list").slideUp(200);
                $(this).siblings(".footer-acnav-list").slideDown(200);
            }
        }
    });

   // custom reviews on product page
  $(window).on('load', function() {
    $(".pdp-right-column").find(".jdgm-prev-badge").append("<a class='product-write-review flex align-center'><svg xmlns='http://www.w3.org/2000/svg' fill='#00000' id='Outline' viewBox='0 0 24 24' width='16' height='16'><path d='M22.853,1.148a3.626,3.626,0,0,0-5.124,0L1.465,17.412A4.968,4.968,0,0,0,0,20.947V23a1,1,0,0,0,1,1H3.053a4.966,4.966,0,0,0,3.535-1.464L22.853,6.271A3.626,3.626,0,0,0,22.853,1.148ZM5.174,21.122A3.022,3.022,0,0,1,3.053,22H2V20.947a2.98,2.98,0,0,1,.879-2.121L15.222,6.483l2.3,2.3ZM21.438,4.857,18.932,7.364l-2.3-2.295,2.507-2.507a1.623,1.623,0,1,1,2.295,2.3Z'></path></svg> Write a Review</a>");
  }); 
     setTimeout(function() {
    $('.pdp-right-column .jdgm-prev-badge').on('click', function() {
    $('.pdp-tab-sec').find("li.active").removeClass('active');
    $('.pdp-tab-sec').find("li[data-tab='pdp-tab-3']").addClass('active');
    $('.tab-content.active').removeClass('active');
    $(".tab-content[id='pdp-tab-3']").addClass('active'); 
    });
  }, 1000); 

   setTimeout(function() {
    $('.pdp-right-column .jdgm-prev-badge').on('click', function() {
    $('.pdp-tab').find('.review_tab').addClass('is-open');
    $('.review_tab.is-open').find('.acnav-list').css('display','block');  
    });
  }, 1000); 

   // notify me
            $('body').on('click','.notify-btn', function(e) {
                e.preventDefault();
                $('body').addClass('no_scroll notify-active');
                $('.out-of-stock-form,.overlay').addClass('active');
              });
             $('body').on('click','.overlay,.notify-popup-close', function(e) {
                e.preventDefault();
               $('body').removeClass('no_scroll notify-active');
                $('.out-of-stock-form,.overlay').removeClass('active');
              });
   var swiper = new Swiper(".related-sidebar-slider", {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    speed: 800,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      475: {
        slidesPerView: 1,
      },
    },
  });

    /********* Mobile Filter Popup ********/
    $('.mobile-facets__open').on('click', function (e) {
      $('body').addClass('mobile-open no_scroll');
      $('.overlay').addClass('active');
    });
    $('.overlay,.close-filter,.apply-btn').on('click', function (e) {
      $('body').removeClass('mobile-open no_scroll overflow-hidden-mobile');
      $('.overlay').removeClass('active');
    }); 
  
  /********* category product ********/
    $(".list-view").click(function () {
      $(".list-view").addClass("active");
      $(".grid-view").removeClass("active");

      $(".grid-product .row").addClass("product-list-view ");
      $(".grid-product .row").removeClass("product-grid-view");

      jQuery('.product-list-view > .grid__item').each(function() {
        var prod_img = jQuery(this).find('.product-card-image');
        jQuery(this).find('.product-content-top').insertAfter(prod_img);
        
        var prod_lable = jQuery(this).find('.product-content-top');
        jQuery(this).find('.product-label-wrp').prependTo(prod_lable);

        var prod_lable = jQuery(this).find('.product-content-top');
        jQuery(this).find('h3').appendTo(prod_lable); 
          
        var coll_count = jQuery(this).find('h3');
        jQuery(this).find('.product-content-top p').insertAfter(coll_count);
          
        var coll_count = jQuery(this).find('.product-content-top');
        jQuery(this).find('.time-counter').appendTo(coll_count);
          
        var prod_right = jQuery(this).find('.product-content-top');
        jQuery(this).find('.product-content-bottom').insertAfter(prod_right);

        var prod_rev = jQuery(this).find('.product-content-bottom');
        jQuery(this).find('.rating-wrp').prependTo(prod_rev);  
          
        var prod_btn = jQuery(this).find('.product-content-bottom');
        jQuery(this).find('.pro-btn-wrapper').appendTo(prod_btn);

        var prod_form = jQuery(this).find('.product-content-bottom');
        jQuery(this).find('.price').appendTo(prod_form);  

        var prod_pri = jQuery(this).find('.price');
        jQuery(this).find('.color-variant-swatch').insertAfter(prod_pri);

        var prod_add = jQuery(this).find('.product-content-bottom');
        jQuery(this).find('.product-form').appendTo(prod_add);  
      });
    });
    $(".grid-view").click(function () {
      $(".grid-view").addClass("active");
      $(".list-view").removeClass("active");

      $(".grid-product .row").addClass("product-grid-view");
      $(".grid-product .row").removeClass("product-list-view");

      jQuery('.product-grid-view > .grid__item').each(function() {
        
        var div_con = jQuery(this).find('.product-card-image');
        jQuery(this).find('.product-content').insertAfter(div_con);
        
        var div_left = jQuery(this).find('.product-content');
        jQuery(this).find('.product-content-top').prependTo(div_left);

        var div_right = jQuery(this).find('.product-content-top');
        jQuery(this).find('.product-content-bottom').insertAfter(div_right);

        var prod_title = jQuery(this).find('.product-content-top');
        jQuery(this).find('.rating-wrp').appendTo(prod_title);

        var timer_btn = jQuery(this).find('.rating-wrp');
        jQuery(this).find('h3').prependTo(timer_btn);

        var timer_btn = jQuery(this).find('.rating-wrp');
        jQuery(this).find('p').appendTo(timer_btn);
        
        var prod_rew = jQuery(this).find('.product-content-bottom');
        jQuery(this).find('.price').prependTo(prod_rew);

        var prod_btn = jQuery(this).find('.price');
        jQuery(this).find('.color-variant-swatch').insertAfter(prod_btn);  
      
          var prod_btn = jQuery(this).find('.product-card-image');
        jQuery(this).find('.time-counter').appendTo(prod_btn);

        var prod_label = jQuery(this).find('.product-card-image > a:last-child');
        jQuery(this).find('.pro-btn-wrapper').insertAfter(prod_label);

        var prod_btn2 = jQuery(this).find('.pro-btn-wrapper');
        jQuery(this).find('.product-label-wrp').insertAfter(prod_btn2); 

        var prod_btn = jQuery(this).find('.pro-btn-wrapper');
        jQuery(this).find('.product-form').prependTo(prod_btn);
      });
    });

    /** counter js **/
    $('.counting').each(function () {
        var $this = $(this),
            countTo = $this.attr('data-count');

        $({ countNum: $this.text() }).animate({
            countNum: countTo
        },
            {
                duration: 3000,
                easing: 'linear',
                step: function () {
                    $this.text(Math.floor(this.countNum));
                },
                complete: function () {
                    $this.text(this.countNum);
                }

            });
    });

    /** Products slider **/
    var swiper = new Swiper(".product-slider", {
        spaceBetween: 20,
        slidesPerColumn: 2,
        slidesPerView: 4,
        speed: 800,
        grid: {
            rows: 2,
        },
        scrollbar: {
            el: ".swiper-scrollbar",
            draggable: true,
        },
        breakpoints: {
            1200: {
                slidesPerView: 4,
                grid: {
                    rows: 2,
                },
            },
            1024: {
                slidesPerView: 3,
                grid: {
                    rows: 2,
                },
            },
            768: {
                slidesPerView: 3,
                grid: {
                    rows: 2,
                },
            },
            575: {
                slidesPerView: 2,
                grid: {
                    rows: 1,
                },
            },
            320: {
                slidesPerView: 1,
                grid: {
                    rows: 1,
                },
            },
            0: {
                slidesPerView: 1,
                grid: {
                    rows: 1,
                },
            },
        },
    });
    /** partner logo slider **/
    var swiper = new Swiper(".partner-logo-slider", {
        slidesPerView: 3,
        loop: true,
        autoplay: true,
        speed: 800,
        spaceBetween: 20,
        breakpoints: {
            1200: {
                slidesPerView: 6,
            },
            992: {
                slidesPerView: 5,
            },
            768: {
                slidesPerView: 4,
            },
            576: {
                slidesPerView: 3,
            },
            0: {
                slidesPerView: 2,
            },
        },
    });

    /** testimonial slider **/
    var swiper = new Swiper(".testimonial-slider", {
        slidesPerView: 3,
        spaceBetween: 30,
        loop: true,
        autoplay: true,
        speed: 800,
        navigation: {
            nextEl: ".testimonial-arrow.swiper-button-next",
            prevEl: ".testimonial-arrow.swiper-button-prev",
        },
        breakpoints: {
            992: {
                slidesPerView: 2,
                direction: 'vertical',
            },
            576: {
                slidesPerView: 2,
                direction: 'horizontal',
                spaceBetween: 15,
            },
            0: {
                slidesPerView: 1,
                direction: 'horizontal',
            },
        },
    });

    /** blog slider **/
    var swiper = new Swiper(".blog-slider", {
        slidesPerView: 3,
        speed: 800,
        loop: true,
        spaceBetween: 20,
        navigation: {
            nextEl: ".blog-arrow.swiper-button-next",
            prevEl: ".blog-arrow.swiper-button-prev",
        },
        breakpoints: {
            576: {
                slidesPerView: 2,
            },
            0: {
                slidesPerView: 1,
            },
        },
    });

      // product slider zoom
    $('.pdp-slider-img.zoom').each(function() {
      $(this).zoom({
        url: false,
        callback: false,
        target: false,
        duration: 120,
        on: 'mouseover', // other options: grab, click, toggle
        touch: true, // enables a touch fallback
        onZoomIn: false,
        onZoomOut: false,
        magnify: 1
      });
    });

  /****** product thumb left page slider *****/
  var leftgalleryThumbs = new Swiper(".left-thumbslider", {
    centeredSlides: false,
    centeredSlidesBounds: true,
    slidesPerView: 5,
    spaceBetween: 10,
    watchOverflow: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    direction: "vertical",
    breakpoints: {
      1200:{
        slidesPerView: 4,
         direction: "vertical",
      },
      992:{
        slidesPerView: 4,
        direction: "vertical",
      },
      768: {
        direction: 'horizontal', 
        slidesPerView: 3,
        spaceBetween: 15,
      },
      576: {
        direction: 'horizontal', 
        slidesPerView: 4,
      },
      320: {
        direction: 'horizontal',
        slidesPerView: 3,
      },
      0: {
        direction: 'horizontal',
        slidesPerView: 3,
      },
    },
  });

  var leftgalleryMain = new Swiper(".left-mainslider", {
    watchOverflow: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
     spaceBetween: 10,
    preventInteractionOnTransition: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    thumbs: {
      swiper: leftgalleryThumbs
    }
  });

  leftgalleryMain.on('slideChangeTransitionStart', function() {
    leftgalleryThumbs.slideTo(leftgalleryMain.activeIndex);
  });

  leftgalleryThumbs.on('transitionStart', function(){
    leftgalleryMain.slideTo(leftgalleryThumbs.activeIndex);
  });

    /** blog page elegant slider **/
    var swiper = new Swiper(".elegant-slider", {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: true,
        autoplay: true,
        speed: 800,
        navigation: {
            nextEl: ".elegant-arrow.swiper-button-next",
            prevEl: ".elegant-arrow.swiper-button-prev",
        },
        breakpoints: {
            320: {
                slidesPerView: 1,
            },
        },
    });

    /** Team slider **/
    var swiper = new Swiper(".about-team-slider", {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: true,
        autoplay: true,
        speed: 800,
        breakpoints: {
            992: {
                slidesPerView: 4,
            },
            768: {
                slidesPerView: 3,
            },
            576: {
                slidesPerView: 2,
            },
            0: {
                slidesPerView: 1,
            },
        },
    });

    /** contact-slider **/
    var swiper = new Swiper(".contact-slider", {
        slidesPerView: 3,
        spaceBetween: 0,
        speed: 800,
        navigation: {
                  nextEl: ".service-arrow.swiper-button-next",
                  prevEl: ".service-arrow.swiper-button-prev",
              },
        breakpoints: {
            992: {
                slidesPerView: 3,
            },
            576: {
                slidesPerView: 2,
            },
            0: {
                slidesPerView: 1,
            },
        },
    });

// load-more button scroll
if ($('.load-more_wrap').hasClass('load-more-btn')) {

  function applyListViewToNewItems($items) {
    $items.each(function() {
      var $item = $(this);

      var prod_img = $item.find('.product-card-image');
      $item.find('.product-content-top').insertAfter(prod_img);

      var prod_label = $item.find('.product-content-top');
      $item.find('.product-label-wrp').prependTo(prod_label);

      var prod_label2 = $item.find('.product-content-top');
      $item.find('h3').appendTo(prod_label2);

      var coll_count = $item.find('h3');
      $item.find('.product-content-top p').insertAfter(coll_count);

      var coll_count2 = $item.find('.product-content-top');
      $item.find('.time-counter').appendTo(coll_count2);

      var prod_right = $item.find('.product-content-top');
      $item.find('.product-content-bottom').insertAfter(prod_right);

      var prod_rev = $item.find('.product-content-bottom');
      $item.find('.rating-wrp').prependTo(prod_rev);

      var prod_btn = $item.find('.product-content-bottom');
      $item.find('.pro-btn-wrapper').appendTo(prod_btn);

      var prod_form = $item.find('.product-content-bottom');
      $item.find('.price').appendTo(prod_form);

      var prod_pri = $item.find('.price');
      $item.find('.color-variant-swatch').insertAfter(prod_pri);

      var prod_add = $item.find('.product-content-bottom');
      $item.find('.product-form').appendTo(prod_add);
    });
  }

  function applyGridViewToNewItems($items) {
    $items.each(function() {
      var $item = $(this);

      var div_con = $item.find('.product-card-image');
      $item.find('.product-content').insertAfter(div_con);

      var div_left = $item.find('.product-content');
      $item.find('.product-content-top').prependTo(div_left);

      var div_right = $item.find('.product-content-top');
      $item.find('.product-content-bottom').insertAfter(div_right);

      var prod_title = $item.find('.product-content-top');
      $item.find('.rating-wrp').appendTo(prod_title);

      var timer_btn = $item.find('.rating-wrp');
      $item.find('h3').prependTo(timer_btn);

      var timer_btn2 = $item.find('.rating-wrp');
      $item.find('p').appendTo(timer_btn2);

      var prod_rew = $item.find('.product-content-bottom');
      $item.find('.price').prependTo(prod_rew);

      var prod_btn = $item.find('.price');
      $item.find('.color-variant-swatch').insertAfter(prod_btn);

      var prod_btn_img = $item.find('.product-card-image');
      $item.find('.time-counter').appendTo(prod_btn_img);

      var prod_label = $item.find('.product-card-image > a:last-child');
      $item.find('.pro-btn-wrapper').insertAfter(prod_label);

      var prod_btn2 = $item.find('.pro-btn-wrapper');
      $item.find('.product-label-wrp').insertAfter(prod_btn2);

      var prod_btn3 = $item.find('.pro-btn-wrapper');
      $item.find('.product-form').prependTo(prod_btn3);
    });
  }

  function loadMoreProducts(nextUrl, totalPages) {
    var $button = $('.js-load-more');

    $button.attr('disabled', true);
    $button.addClass('hide');
    $button.siblings('[loader]').removeClass('hide');

    $.ajax({
      url: nextUrl,
      type: 'GET',
      dataType: 'html',

      success: function(responseHTML) {
        var $response = $(responseHTML);
        var $newProducts = $response.find('.grid-product .row > .grid__item');

        $('.grid-product .row').append($newProducts);

        if ($('.list-view').hasClass('active')) {
          $('.grid-product .row').addClass('product-list-view').removeClass('product-grid-view');
          applyListViewToNewItems($newProducts);
        } else {
          $('.grid-product .row').addClass('product-grid-view').removeClass('product-list-view');
          applyGridViewToNewItems($newProducts);
        }

        var newNextUrl = $response.find('[data-next-link]').val();
        var newCurrentPage = parseInt($response.find('[data-this-page]').val());
        var newTotalPages = parseInt($response.find('[data-all-pages]').val());

        if (newNextUrl) {
          $('[data-next-link]').val(newNextUrl);
        }

        if (!isNaN(newCurrentPage)) {
          $('[data-this-page]').val(newCurrentPage);
        }

        if (!isNaN(newTotalPages)) {
          $('[data-all-pages]').val(newTotalPages);
        }

        countDownIni('.flip-countdown,.js-flip-countdown');
      },

      complete: function() {
        var currentPage = parseInt($('[data-this-page]').val());
        var totalPages = parseInt($('[data-all-pages]').val());

        if (currentPage < totalPages) {
          $button.attr('disabled', false);
          $button.removeClass('hide');
          $button.siblings('[loader]').addClass('hide');
        } else {
          $button.parents('.load-more_wrap').addClass('hide');
        }
      }
    });
  }

  $('.js-load-more').on('click', function() {
    var nextUrl = $('[data-next-link]').val();
    var totalPages = parseInt($('[data-all-pages]').val());
    loadMoreProducts(nextUrl, totalPages);
  });

}
// load-more button scroll end
// infinite scroll
if ($('.load-more_wrap').hasClass('infinite-scroll')) {

  var infinitelastLoadedUrl = "";

  function applyListViewToNewItems($items) {
    $items.each(function() {
      var $item = $(this);

      var prod_img = $item.find('.product-card-image');
      $item.find('.product-content-top').insertAfter(prod_img);

      var prod_label = $item.find('.product-content-top');
      $item.find('.product-label-wrp').prependTo(prod_label);

      var prod_label2 = $item.find('.product-content-top');
      $item.find('h3').appendTo(prod_label2);

      var coll_count = $item.find('h3');
      $item.find('.product-content-top p').insertAfter(coll_count);

      var coll_count2 = $item.find('.product-content-top');
      $item.find('.time-counter').appendTo(coll_count2);

      var prod_right = $item.find('.product-content-top');
      $item.find('.product-content-bottom').insertAfter(prod_right);

      var prod_rev = $item.find('.product-content-bottom');
      $item.find('.rating-wrp').prependTo(prod_rev);

      var prod_btn = $item.find('.product-content-bottom');
      $item.find('.pro-btn-wrapper').appendTo(prod_btn);

      var prod_form = $item.find('.product-content-bottom');
      $item.find('.price').appendTo(prod_form);

      var prod_pri = $item.find('.price');
      $item.find('.color-variant-swatch').insertAfter(prod_pri);

      var prod_add = $item.find('.product-content-bottom');
      $item.find('.product-form').appendTo(prod_add);
    });
  }

  function applyGridViewToNewItems($items) {
    $items.each(function() {
      var $item = $(this);

      var div_con = $item.find('.product-card-image');
      $item.find('.product-content').insertAfter(div_con);

      var div_left = $item.find('.product-content');
      $item.find('.product-content-top').prependTo(div_left);

      var div_right = $item.find('.product-content-top');
      $item.find('.product-content-bottom').insertAfter(div_right);

      var prod_title = $item.find('.product-content-top');
      $item.find('.rating-wrp').appendTo(prod_title);

      var timer_btn = $item.find('.rating-wrp');
      $item.find('h3').prependTo(timer_btn);

      var timer_btn2 = $item.find('.rating-wrp');
      $item.find('p').appendTo(timer_btn2);

      var prod_rew = $item.find('.product-content-bottom');
      $item.find('.price').prependTo(prod_rew);

      var prod_btn = $item.find('.price');
      $item.find('.color-variant-swatch').insertAfter(prod_btn);

      var prod_btn_img = $item.find('.product-card-image');
      $item.find('.time-counter').appendTo(prod_btn_img);

      var prod_label = $item.find('.product-card-image > a:last-child');
      $item.find('.pro-btn-wrapper').insertAfter(prod_label);

      var prod_btn2 = $item.find('.pro-btn-wrapper');
      $item.find('.product-label-wrp').insertAfter(prod_btn2);

      var prod_btn3 = $item.find('.pro-btn-wrapper');
      $item.find('.product-form').prependTo(prod_btn3);
    });
  }

  function infiniteloadMoreProducts(nextUrl, totalPages) {
    if (!nextUrl || nextUrl === infinitelastLoadedUrl) {
      return;
    }

    infinitelastLoadedUrl = nextUrl;

    $('[loader]').removeClass('hide');

    $.ajax({
      url: nextUrl,
      type: 'GET',
      dataType: 'html',

      success: function(responseHTML) {
        var $response = $(responseHTML);
        var $newProducts = $response.find('.grid-product .row > .grid__item');

        if (!$newProducts.length) {
          $('[loader]').addClass('hide');
          return;
        }

        $('.grid-product .row').append($newProducts);

        if ($('.list-view').hasClass('active')) {
          $('.grid-product .row').addClass('product-list-view').removeClass('product-grid-view');
          applyListViewToNewItems($newProducts);
        } else {
          $('.grid-product .row').addClass('product-grid-view').removeClass('product-list-view');
          applyGridViewToNewItems($newProducts);
        }

        var newNextUrl = $response.find('[data-next-link]').val();
        var newCurrentPage = parseInt($response.find('[data-this-page]').val());
        var newTotalPages = parseInt($response.find('[data-all-pages]').val());

        if (newNextUrl) {
          $('[data-next-link]').val(newNextUrl);
        } else {
          $('[data-next-link]').val('');
        }

        if (!isNaN(newCurrentPage)) {
          $('[data-this-page]').val(newCurrentPage);
        }

        if (!isNaN(newTotalPages)) {
          $('[data-all-pages]').val(newTotalPages);
        }

        countDownIni('.flip-countdown,.js-flip-countdown');
      },

      complete: function() {
        $('[loader]').addClass('hide');
      }
    });
  }

  $.fn.isInViewport = function() {
    var elementTop = this.offset().top;
    var elementBottom = elementTop + this.outerHeight();
    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();
    return elementBottom > viewportTop && elementTop < viewportBottom;
  };

  $(window).on('scroll load', function() {
    if ($('.load-more_wrap').isInViewport()) {
      var currentPage = parseInt($('[data-this-page]').val());
      var nextUrl = $('[data-next-link]').val();
      var totalPages = parseInt($('[data-all-pages]').val());

      if (!nextUrl || currentPage >= totalPages) {
        $('[loader]').addClass('hide');
        return;
      }

      infiniteloadMoreProducts(nextUrl, totalPages);
    }
  });
}
// end infinite
  
function responsiveMenu(){
  if(jQuery(window).width() < 768) {
    $('.product-filter-column').prependTo('.product-heading-row .container .row .product-heading-column');
  }
  else { 
    $('.product-filter-column').prependTo('.product-list-row');
    if($('body').hasClass('mobile-open') ){
      $('body').removeClass('mobile-open no_scroll overflow-hidden-mobile');
      $('.overlay').removeClass('active');
     }
  }

   if(jQuery(window).width() < 992) {
     if(!$('.mobile-lag').length > 0 ){
      const newDiv = document.createElement('div');
      newDiv.className = 'mobile-lag flex align-center';
      $(newDiv).insertAfter('.menu-close-icon');
      $('.currency, .languages').prependTo('.mobile-lag');
    }else{
       return false;
    }
  }
  else {
    $('.currency, .languages').prependTo('.announcebar-right');
    $('.mobile-lag').remove();
  }
  
}
  jQuery(document).ready(function() {
    responsiveMenu();
  });
  jQuery(window).resize(function() {
    responsiveMenu();
  });
});

function countDownIni(countdown) {
 $(countdown).each(function () {
   var countdown = $(this);
   var promoperiod;
   if (countdown.attr('data-promoperiod')) {
     promoperiod = new Date().getTime() + parseInt(countdown.attr('data-promoperiod'), 10);
   } else if (countdown.attr('data-countdown')) {
     promoperiod = countdown.attr('data-countdown');
   }
   if (Date.parse(promoperiod) - Date.parse(new Date()) > 0) {
     $(this).addClass('countdown-block');
     countdown.countdown(promoperiod, function (event) {
       // countdown.html(event.strftime('%-w weeks %-d days %Hh %Mm %Ss'));
       countdown.html(event.strftime("<div class='counter'><span class='count count-days'>%D</span><span class='counter-dtl'>days</span></div>" + "<div class='counter'><span class='count count-hours'>%H</span><span class='counter-dtl'>hrs</span></div>" + "<div class='counter'><span class='count count-minites'>%M</span><span class='counter-dtl'>mins</span></div>" + "<div class='counter'><span class='count count-seconds'>%S</span><span class='counter-dtl'>secs</span></div>"));
     });
   }
    if (Date.parse(promoperiod) - Date.parse(new Date()) < 0) {
        $(this).parent().css('display','none');
        $(this).parents('.pdp-timer').css('display','none');
     }
 });
}